export const PRODUCT_ATTRIBUTE = {
    SIZE:       'SIZE',
    GENERAL:    'GENERAL',
    EFFECT:     'EFFECT',
    INGREDIENT: 'INGREDIENT',
    FLAVOR:     'FLAVOR',
    SUBTYPE:    'SUBTYPE',
    MGDOSE:     'MGDOSE',
    TOTALDOSES: 'TOTALDOSES',
    MEDIUM:     'MEDIUM',
};



// WEBPACK FOOTER //
// ./src/const/attribute.js